import Vue from 'vue'
import Main from './main.vue'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const AddressBook = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      campusId: options.campusId,
      studentGroupId: options.studentGroupId || null,
      sandboxId: options.sandboxId, // 沙盒
      sandboxType: options.sandboxType || 1, // 沙盒类型
      addressType: options.addressType || 1, // 通讯录业务类型： 默认1 宿管通讯录2
      showTag: typeof options.showTag === 'boolean' ? options.showTag : true, // 直接退出是否需要返回
      tagId: options.tagId || null, // 选择部门时 标签选择
      needReturn: options.needReturn || false, // 直接退出是否需要返回
      removeDelay: options.removeDelay || 0, // 是否延时去除dom
      isSandboxComplete: options.isSandboxComplete,
      memberCount: options.memberCount || 0, // 已选择多少人
      checkMemberConflict: options.checkMemberConflict, // 是否作为选择考勤人员进行人员冲突判断
      conflictText: options.conflictText || '考勤'
    }
    // eslint-disable-next-line space-before-function-paren
    _options.close = function (result) {
      let _params = {
        removeDelay: _options.removeDelay
      }
      AddressBook.close(_params)
        .then(res => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line space-before-function-paren
    _options.closeOnly = function () {
      let _params = {
        removeDelay: _options.removeDelay
      }
      AddressBook.close(_params)
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : ''
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({ data: _options })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    if (!_options.appendNode) {
      document.body.appendChild(MInstance.dom) // 将dom插入body
    } else {
      document.getElementById('app').appendChild(MInstance.dom)
    }

    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
AddressBook.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default AddressBook
